var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide"},on:{"before-enter":_vm.beforeEnter,"leave":_vm.leave}},[(_vm.visible)?_c('div',{ref:"carousel",staticClass:"carousel-item",class:( _obj = {reverse: _vm.reverse}, _obj[_vm.exhibitionStyle] = _vm.card, _obj ),on:{"touchmove":_vm.xxx,"touchstart":_vm.stopCarousel,"touchend":_vm.startCarousel,"click":_vm.bounce}},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }